import { $streemApiAdmin } from "shared/boot/api";
import ApiClient from "shared/services/api/ApiClient";

class UserService extends ApiClient {
  constructor() {
    super("/users", $streemApiAdmin.client);
  }

  role(user) {
    return this.put(`/${user.id}/role`, {
      params: {
        user,
      },
    });
  }

  team(user) {
    return this.put(`/${user.id}/team`, {
      params: {
        user,
      },
    });
  }

  getAuthTokens(userId) {
    return this.get(`/${userId}/auth_tokens`);
  }

  invalidateUserTokens(userId) {
    return this.get(`/${userId}/invalidate_tokens`);
  }

  resetPassword(user) {
    return this.post(`/${user.id}/reset_password`);
  }

  sendWelcome(userId, emailAccountManagers, welcomeEmailOption = "standard") {
    return this.put(`/${userId}/welcome`, {
      params: {
        welcome_email_option: welcomeEmailOption,
        email_account_managers: emailAccountManagers,
      },
    });
  }

  async openInDesktopApp(user, accountManager = null, redirectUrl = null) {
    const url = await this.getDesktopAppUrl(user, accountManager, redirectUrl);
    window.open(url, "_blank");
  }

  async openInMobileApp(user) {
    const url = await this.getMobileAppUrl(user);
    window.open(url, "_blank");
  }

  async getDesktopAppUrl(user, accountManager = null, redirectUrl = null) {
    const response = await this.getAuthTokens(user.id);
    const tokens = response.data;

    let url = `${import.meta.env.VITE_DESKTOP_APP_URL}/sign-in?auth_token=${
      tokens[0]
    }`;

    if (accountManager) {
      const attributes = {
        id: accountManager.id,
        name: `${accountManager.first_name} ${accountManager.last_name}`,
        email: accountManager.email,
      };

      url += `&account_manager=${encodeURIComponent(
        JSON.stringify(attributes)
      )}`;
    }

    if (redirectUrl) url += `&redirect=${encodeURIComponent(redirectUrl)}`;

    return url;
  }

  async getMobileAppUrl(user) {
    const response = await this.getAuthTokens(user.id);
    const tokens = response.data;

    const url = `${import.meta.env.VITE_MOBILE_URL}/sign-in?auth_token=${
      tokens[0]
    }`;

    return url;
  }
}

export default new UserService();
